import React from "react";

//UI Material
import { Card, Divider, Grid, Stack, Typography } from "@mui/material";

//Material Icons
import { DeliveryDining, Notes } from "@mui/icons-material";
import ElementCard from "../../ProComponents/ElementCard";

export default function QuoteBilling({ data }) {
  //Function to generate quote amounts
  const generateQuoteAmount = () => {
    let pretaxAmount = 0;
    let taxes = 0;
    for (const product of data.products) {
      let beforeTaxes = Number(product.price) * product.quantity;

      pretaxAmount += beforeTaxes;
    }
    let discount = pretaxAmount * (data.billing.discountPercentage / 100);
    pretaxAmount -= discount;
    taxes = pretaxAmount * (data.billing.taxesPercentage / 100);
    return {
      subtotal: Number(pretaxAmount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      discount: Number(discount).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      iva: Number(taxes).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
      total: Number(pretaxAmount + taxes).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    };
  };

  const generateCurrencyIcon = () => {
    if (data.billing.currency === "CRC") {
      return "₡";
    } else {
      return "$";
    }
  };

  return (
    <Card raised>
      <Grid container textAlign="left" sx={{ padding: 2 }} spacing={2}>
        <Grid item xs={12}>
          <ElementCard
            ops={{
              title: "Información de facturación",
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="h6" fontWeight="bold">
            {`${generateCurrencyIcon()} ${generateQuoteAmount().total}`}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider flexItem />
        </Grid>
        <Grid item xs={6}>
          <Stack>
            <Typography fontWeight="bold">
              {`Monto sin impuestos (${generateCurrencyIcon()})`}
            </Typography>
            <Typography>{`${generateCurrencyIcon()}${
              generateQuoteAmount().subtotal
            }`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack>
            <Typography fontWeight="bold">
              {`Descuento ${
                data.billing.discountPercentage
              }% (${generateCurrencyIcon()})`}
            </Typography>
            <Typography>{`(${generateCurrencyIcon()}${
              generateQuoteAmount().discount
            })`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack>
            <Typography fontWeight="bold">
              {`IVA ${
                data.billing.taxesPercentage
              }% (${generateCurrencyIcon()})`}
            </Typography>
            <Typography>{`${generateCurrencyIcon()}${
              generateQuoteAmount().iva
            }`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack>
            <Typography fontWeight="bold">{`Monto total (${generateCurrencyIcon()})`}</Typography>
            <Typography>{`${generateCurrencyIcon()}${
              generateQuoteAmount().total
            }`}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack>
            <Typography fontWeight="bold">{`Método de pago`}</Typography>
            <Typography>{data.billing.paymentMethod}</Typography>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="row" alignItems="flex-start" spacing={1}>
            <DeliveryDining />
            <Stack>
              <Typography fontWeight="bold">{`Información de entrega`}</Typography>
              <Typography>
                {data.billing.aditional || "Sin especificar"}
              </Typography>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6}>
          <Stack direction="row" alignItems="flex-start" spacing={1}>
            <Notes />
            <Stack>
              <Typography fontWeight="bold">{`Notas de la cotización`}</Typography>
              <Typography>{data.notes}</Typography>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
